import cn from 'classnames';
import Flex from '@creditflowresearch/uilib/Flex';
import Tag from './Tag';

import styles from './filterTags.module.scss';

export interface IFilterTagItem {
  key: string,
  label: string,
  isExclude?: boolean,
  removable?: boolean,
}

interface IFilterTagsProps {
  tags: IFilterTagItem[],
  onTagRemove: (tagKey: string) => void,
  dataTest?: string,
  emptyText?: string,
}

const FilterTags = ({
  tags,
  onTagRemove,
  dataTest = 'filterTags',
  emptyText = 'No Filters Selected',
}: IFilterTagsProps) => {
  if (tags.length === 0) {
    return <p className={ styles.emptyText } data-test={ `${ dataTest }Empty` }>{ emptyText }</p>;
  }

  return (
    <Flex wrap="wrap" gap={ 6 } dataTest={ dataTest }>
      { tags.map(({ key, label, isExclude, removable = true }) => (
        <Tag
          key={ key }
          dataTest={ `filterTag_${ key }` }
          title={ isExclude ? `Exclude: ${ label }` : label }
          onClick={ removable ? () => onTagRemove(key) : undefined }
          allowedToRemove={ removable }
          className={ cn({ [styles.nonRemovableTag]: !removable }) }
        />
      )) }
    </Flex>
  );
};

export default FilterTags;
